module.exports = __webpack_public_path__ + "static/media/avanser_logo_without_text.24d03fd8.png";